import { render, staticRenderFns } from "./CandidateRegistrationChart.vue?vue&type=template&id=5036ddcb&scoped=true&"
import script from "./CandidateRegistrationChart.vue?vue&type=script&lang=js&"
export * from "./CandidateRegistrationChart.vue?vue&type=script&lang=js&"
import style0 from "./CandidateRegistrationChart.vue?vue&type=style&index=0&id=5036ddcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036ddcb",
  null
  
)

export default component.exports